import React, { FC } from 'react';
import AccessRepositories from '../../components/core/AccessRepositories/AccessRepositories';
import ListRepositories from '../../components/core/ListRepositories/ListRepositories';
import PrimaryNavigation from '../../components/core/PrimaryNavigation/PrimaryNavigation';
import RepositoryAccess from '../../redux/slices/RepositoryAccess';
import AdminRepositoryAccess from '../AdminRepositoryAccess/AdminRepositoryAccess';

import './PortalDocumentsAccess.css';
interface PortalDocumentsAccessProps {}

const PortalDocumentsAccess: FC<PortalDocumentsAccessProps> = () => (
  <div className="PortalDocumentsAccess">
          <PrimaryNavigation />
          <div className="container-access-repositories">
         <AccessRepositories></AccessRepositories>
          </div>
      </div>
);

export default PortalDocumentsAccess;